export enum OrderStatuses {
  IN_PROGRESS = 'in progress',
  DONE = 'done',
  CANCELED = 'canceled',
}

export enum ShowingOrderStatuses {
  'in progress' = 'Pending',
  done = 'Issued',
  canceled = 'Canceled',
}
